import { moduleProviderFactory } from 'core/providers';
import { CarrierList } from 'modules/carrier/pages';

(function() {
	moduleProviderFactory.application.register({
		routes: [
			{
				name: 'master.app.main.carrier',
				pattern: '/carriers',
				isPrivate: true,
				children: [
					{
						name: 'master.app.main.carrier.list',
						pattern: 'carrier',
						authorization: 'shippingCarrierSection.full',
						component: CarrierList,
					},
				],
			},
		],
	});
})();
